(() => {
  const visibleSet = new Set();
  let pollTimer;
  const pollMe = () => {
    window.swinger.user.updateUserData();
  };
  const toggleActivate = () => {
    if (!window.swinger.user.isLoggedIn() && visibleSet.size) {
      pollTimer = window.setInterval(pollMe, 2000);
    } else {
      window.clearInterval(pollTimer);
    }
  };

  window.swinger.eventHub.register('error', '.swinger-login-qr-code img', () => {
    window.swinger.user.updateUserData();
  });

  window.swinger.observer.initialize('.swinger-login-qr-code', (elem) => {
    window.swinger.visibility.observe(elem, (visible) => {
      visibleSet[visible ? 'add' : 'delete'](elem);
      toggleActivate();
    });
  }, false);

  document.addEventListener('swinger.user:authchange', () => {
    toggleActivate();
  });
})();
